import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { Redirect, Link, withRouter, useLocation, useHistory } from "react-router-dom";
import { Icon, Table, Form, Input, notification, Modal, Select, Dropdown, Menu } from "antd";
import axios from "axios";
import moment from "moment";

import ModalGerarDocumento from "../../../../shared/components/Modals/GerarDocumento";
import ModalLoading from "../../../../shared/components/Modals/ModalLoading";

import DrawerLogs from "../../../../GerirDetalheTurma/Aproveitamento/Drawer/DrawerLogs";
import DrawerDataLimiteNota from "../../../../GerirDetalheTurma/Aproveitamento/Drawer/DrawerDataLimite";
import DrawerAlterarConceito from "../../../../GerirDetalheTurma/Aproveitamento/Drawer/DrawerAlterarConceito";

import { validarExistemNotas, validarExistemObs } from "../../../../shared/utils/Diario/Aproveitamento/validacoes";

import { GlobalContext } from "../../../../app/providers/GlobalState";
import { GeralContext } from "../../../ContextProvider";

import { base64DecodeToLong } from "../../../../shared/utils/base64";

const { Option } = Select;
const { TextArea } = Input;
const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
    state = {
        editing: false,
        classificacoes: []
    };

    UNSAFE_componentWillMount() {
        this.info();
    }

    toggleEdit = () => {
        const { record } = this.props;

        if (record.permissao || record.permissaoAdm) {
            const editing = !this.state.editing;
            this.setState({ editing }, () => {
                if (editing) {
                    this.input.focus();
                }
            });
        }
    };

    save = e => {
        const { record, handleSave } = this.props;
        this.form.validateFields((error, values) => {
            if (error && error[e.currentTarget.id]) {
                return;
            }
            this.toggleEdit();

            handleSave({ ...record, ...values });
        });
    };

    saveSelect = e => {
        const { record, handleSave } = this.props;
        const cor = this.state.classificacoes.find(x => x.nome === e)?.cor;

        handleSave({ ...record, nota: e, cor });
        this.toggleEdit();
    };

    renderCell = form => {
        this.form = form;
        const { children, dataIndex, record, title } = this.props;
        const { editing } = this.state;
        return editing ? (
            <Form.Item style={{ margin: 0 }}>
                {form.getFieldDecorator(dataIndex, {
                    //rules: [
                    //    {
                    //        required: dataIndex != "observacoes",
                    //        message: "Campo obrigatório",
                    //    },
                    //],
                    initialValue: record[dataIndex]
                })(
                    dataIndex === "nota" ? (
                        <Select
                            placeholder="Selecionar"
                            ref={node => (this.input = node)}
                            onPressEnter={this.saveSelect}
                            onBlur={this.saveSelect}
                            style={{ width: 100 }}
                        >
                            {this.state.classificacoes.map((classificacao, index) => (
                                <Option key={index} value={classificacao.nome}>
                                    {classificacao.nome}
                                </Option>
                            ))}
                        </Select>
                    ) : (
                        <TextArea
                            ref={node => (this.input = node)}
                            onPressEnter={this.save}
                            onBlur={this.save}
                            rows={4}
                            style={{ height: 100 }}
                        />
                    )
                )}
            </Form.Item>
        ) : (
            <div className="editable-cell-value-wrap" style={{ paddingRight: 24 }} onClick={this.toggleEdit}>
                {children}
            </div>
        );
    };

    info = () => {
        axios({
            method: "get",
            url: "/api/aproveitamento/conceitos-classificacoes",
            params: {
                estruturaId: JSON.parse(localStorage.getItem("aproveitamento")).estrutura
            }
        })
            .then(response => {
                this.setState({
                    classificacoes: response.data
                });
            })
            .catch(error => {});
    };

    render() {
        const { editable, dataIndex, title, record, index, handleSave, children, ...restProps } = this.props;
        return <td {...restProps}>{editable ? <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer> : children}</td>;
    }
}

const Detalhe = ({ match }) => {
    const disciplinaId =
        localStorage.getItem("vista") === "TURMA"
            ? localStorage.getItem("disciplina_aproveitamento")
            : localStorage.getItem("codigo_curso");

    const [permissao, setPermissao] = useState([]);
    const [fases, setFases] = useState("");
    const [aluno, setAluno] = useState("");
    const [avaliacoes, setAvaliacoes] = useState([]);
    const [legendas, setLegendas] = useState();
    const [loading, setLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [visibleModal, setVisibleModal] = useState(false);
    const [visibleExport, setVisibleExport] = useState(false);
    const [buttonDownload, setButtonDownload] = useState(false);
    const [exportFile, setExportFile] = useState("");
    const [loadingText, setLoadingText] = useState("");
    const [visibleLoading, setVisibleLoading] = useState(false);
    const [avaliacaoId, setAvaliacaoId] = useState(0);
    const [notaId, setNotaId] = useState(0);
    const [visible, setVisible] = useState(false);
    const [expandedRows, setExpandedRows] = useState([]);
    const [grupoInfo, setGrupoInfo] = useState("");
    const [alunos, setAlunos] = useState([]);

    const [estado, setEstado] = useState("");
    const [texto, setTexto] = useState("");
    const [campoCalculado, setCampoCalculado] = useState(false);
    //DRAWER LOGS
    const [visibleDrawerLogs, setVisibleDrawerLogs] = useState(false);
    const [visibleDrawerAlterarDataNota, setVisibleDrawerAlterarDataNota] = useState(false);
    const [visibleDrawerAlterarNota, setVisibleDrawerAlterarNota] = useState(false);

    const context = useContext(GlobalContext);
    const geralContext = useContext(GeralContext);
    const history = useHistory();

    const entidadeId = localStorage.getItem("entidade_id");

    const acesso = context.acessos?.find(x => x.func === 21);
    const acessoApagarRegistos = context.acessos?.find(x => x.func === 25);
    const acessoAlterarData = context.acessos?.find(x => x.func === 28);
    const acessoAlterarNota = context.acessos?.find(x => x.func === 29);

    const location = useLocation();

    const autoSaveTimeoutRef = useRef(null);
    const alteradoPeloUserRef = useRef(false);
    const carregouRef = useRef(false);

    const handleSave = row => {
        const newData = [...avaliacoes];
        const index = newData.findIndex(item => row.key === item.key);
        const item = newData[index];

        const rowTrim = {
            ...row,
            observacoes: row.observacoes?.trim() ?? row.observacoes,
            notaAlterada: item.restauradoRascunhoNota || item.notaAlterada || item.nota !== row.nota,
            observacaoAlterada: item.restauradoRascunhoObservacoes || item.observacaoAlterada || item.observacoes !== row.observacoes
        };

        newData.splice(index, 1, {
            ...item,
            ...rowTrim,
            guardadaBD: false
        });
        setAvaliacoes(newData);

        const itemTrim = {
            ...item,
            observacoes: row.observacoes?.trim() ?? row.observacoes
        };

        const { cor: _, ...rowSemCor } = rowTrim;
        const { cor: __, ...itemSemCor } = itemTrim;

        if (JSON.stringify(rowSemCor) !== JSON.stringify(itemSemCor)) {
            alteradoPeloUserRef.current = true;
        }

        if (estado !== "") setEstado("");
    };

    const guardar = () => {
        if (validarExistemNotas(avaliacoes) || validarExistemObs(avaliacoes)) {
            const lista = avaliacoes.map(avaliacao => {
                return {
                    id: avaliacao.key,
                    nota: avaliacao.nota,
                    observacoes: avaliacao.observacoes
                };
            });

            let item = new FormData();
            item.append("turmaId", disciplinaId);
            item.append("code", match.params.code);
            item.append("pauta", JSON.stringify(lista));

            axios({
                method: "put",
                url: "/api/turma/guardar-pauta-conceitos-aluno",
                data: item
            })
                .then(response => {
                    openNotificationWithIcon("success", "Sucesso", "Resultados guardados.");
                    info();
                    listar();
                    context.atualizarState({
                        existeRascunhoGuardado: false
                    });
                })
                .catch(error => {
                    openNotificationWithIcon("error", "Erro", "Não foi possível guardar os resultados.");
                });
        } else {
            //if (entidadeId == 3)
            openNotificationWithIcon("error", "Erro", "Não foram adicionadas notas ou observações!");
            //else
            //    openNotificationWithIcon("error", "Erro", "Não foram adicionadas notas!");
        }
    };

    const legendasConceitos = () => {
        axios({
            method: "get",
            url: "/api/turma/legendas-conceitos",
            params: {
                cursoId: disciplinaId
            }
        })
            .then(response => {
                setLegendas(response.data);
            })
            .catch(() => {});
    };

    const listar = () => {
        const grupo = JSON.parse(localStorage.getItem("grupo"));

        axios({
            method: "get",
            url: "/api/aproveitamento/listar-items-avaliacao-conceitos-subitems-aluno",
            params: {
                disciplinaId: disciplinaId,
                grupoId: grupo.id,
                code: match.params.code,
                estruturaId: JSON.parse(localStorage.getItem("aproveitamento")).estrutura
            }
        })
            .then(response => {
                let avaliacoes = [];

                response.data.map(registo => {
                    const optionVisivel = registo.logs || acessoAlterarNota != null || acessoAlterarData != null;
                    let data = "";
                    let estado = "";

                    avaliacoes.push({
                        key: registo.id,
                        id: registo.id,
                        idPai: registo.idPai,
                        code: registo.code,
                        epoca: registo.epoca,
                        nome: registo.titulo,
                        autor: registo.autor,
                        data: data,
                        estado: estado,
                        ordem: registo.ordem,
                        nota: registo.nota,
                        cor: registo.cor,
                        observacoes: registo.observacoes,
                        permissao: registo.permissao,
                        permissaoAdm: registo.permissaoAdm,
                        opcoes: optionVisivel && (
                            <Dropdown overlay={montarMenu(registo)} placement="bottomLeft">
                                <Link to="#" className="botao-icon-configs">
                                    <i className="fas fa-cog" />
                                </Link>
                            </Dropdown>
                        )
                    });
                });

                setAvaliacoes(avaliacoes);
            })
            .catch(error => {
                if (error.response.data) openNotificationWithIcon("error", "Erro", error.response.data);
            });
    };

    const cancelarRascunho = () => {
        axios({
            method: "put",
            url: "/api/turma/cancelar-rascunhos",
            params: { grupoId: grupo.id, code: match.params.code }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Rascunho descartado.");

                context.atualizarState({
                    existeRascunhoGuardado: false
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error?.data?.message || "Não foi possível descartar o rascunho.");
            });
    };

    const carregarRascunhoPauta = () => {
        if (carregouRef.current) return;
        else {
            carregouRef.current = true;

            const grupo = JSON.parse(localStorage.getItem("grupo"));

            axios({
                method: "get",
                url: "/api/aproveitamento/listar-items-avaliacao-conceitos-subitems-aluno-rascunho",
                params: {
                    disciplinaId: disciplinaId,
                    grupoId: grupo.id,
                    code: match.params.code,
                    estruturaId: JSON.parse(localStorage.getItem("aproveitamento")).estrutura
                }
            })
                .then(response => {
                    const listaComRascunho = response.data || [];

                    if (!Array.isArray(listaComRascunho) || listaComRascunho.length === 0) return;

                    const temConteudo = listaComRascunho.some(x => x.nota?.toString().trim() || x.observacoes?.toString().trim());

                    if (!temConteudo) return;

                    const datas = listaComRascunho.map(x => x.data && moment(x.data)).filter(m => m && m.isValid());

                    const dtMaisRecente = datas.length ? moment.max(datas) : null;
                    const dataFormatada = dtMaisRecente?.format("DD/MM/YYYY [às] HH:mm") || "";

                    confirm({
                        title: "Rascunho de avaliação encontrado",
                        content: `Encontrámos um rascunho de notas feito no dia ${dataFormatada}. Deseja retomar o preenchimento?`,
                        okText: "Retomar avaliação",
                        cancelText: "Não",
                        onOk: () => {
                            setLoading(true);

                            setAvaliacoes(prev =>
                                prev.map(avaliacao => {
                                    const rascunho = listaComRascunho.find(r => r.id === avaliacao.key);
                                    if (!rascunho) return avaliacao;

                                    return {
                                        ...avaliacao,
                                        ...(rascunho.nota && { nota: rascunho.nota, cor: rascunho.cor }),
                                        ...(rascunho.observacoes && { observacoes: rascunho.observacoes }),
                                        restauradoRascunhoNota: rascunho.nota ? true : false,
                                        restauradoRascunhoObservacoes: rascunho.observacoes ? true : false
                                    };
                                })
                            );

                            setLoading(false);
                        },
                        onCancel: cancelarRascunho
                    });
                })
                .catch(error => {
                    openNotificationWithIcon("error", "Erro", "Não foi possível carregar rascunho!");
                });
        }
    };

    const montarMenu = registo => {
        const { id: avaliacaoId, notaId, logs, transferido } = registo;

        return (
            <Menu>
                {logs && (
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={() => {
                                setNotaId(notaId);
                                setVisibleDrawerLogs(true);
                            }}
                        >
                            Logs
                        </Link>
                    </Menu.Item>
                )}
                {acessoAlterarNota && !transferido && localStorage.getItem("entidade_id") === "33" && (
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={() => {
                                setNotaId(notaId);
                                setVisibleDrawerAlterarNota(true);
                            }}
                        >
                            Alterar nota
                        </Link>
                    </Menu.Item>
                )}
                {acessoAlterarData && !transferido && (
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={() => {
                                setNotaId(notaId);
                                setAvaliacaoId(avaliacaoId);
                                setVisibleDrawerAlterarDataNota(true);
                            }}
                        >
                            Alterar data limite
                        </Link>
                    </Menu.Item>
                )}
            </Menu>
        );
    };

    const info = () => {
        const grupo = JSON.parse(localStorage.getItem("grupo"));

        axios({
            method: "get",
            url: "/api/turma/info-grupo",
            params: {
                grupoId: grupo.id
            }
        })
            .then(response => {
                if (response.data) {
                    if (response.data !== "CAMPO_CALCULADO") {
                        setEstado(response.data.estado);
                        setTexto(response.data.texto);
                        setCampoCalculado(response.data.campoCalculado);
                    } else setCampoCalculado(true);
                }
            })
            .catch(error => {});
    };

    const exportarExcel = () => {
        setVisibleExport(true);
        setButtonDownload(true);
        axios({
            method: "get",
            url: "/api/excel/exportar-conceitos-aluno",
            params: {
                disciplinaId: disciplinaId,
                estruturaId: JSON.parse(localStorage.getItem("aproveitamento")).estrutura,
                code: match.params.code
            }
        })
            .then(response => {
                setButtonDownload(false);
                setExportFile(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                setVisibleExport(false);
            });
    };

    const importarExcel = ficheiro => {
        setVisibleLoading(true);
        setLoadingText("A importar registos...");

        let item = new FormData();
        item.append("code", match.params.code);
        item.append("ficheiro", ficheiro);

        axios({
            method: "put",
            url: "/api/excel/importar-conceitos-aluno",
            data: item
        })
            .then(() => {
                setVisibleLoading(false);
                listar();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data);
                setVisibleLoading(false);
            });
    };

    const validarFormato = formato => {
        var formatos = ["xlsx"];
        var valido = false;
        for (var i = 0; i < formatos.length; i++) {
            if (formato.toLowerCase() === formatos[i]) {
                valido = true;
                break;
            }
        }
        return valido;
    };

    const uploadFoto = event => {
        if (validarFormato(event.target.files[0].name.split(".").pop().toLowerCase())) {
            importarExcel(event.target.files[0]);
            document.getElementById("upload-doc").value = "";
        } else {
            document.getElementById("upload-doc").value = "";
            openNotificationWithIcon("error", "Erro", "Ficheiro com formato inválido");
        }
    };

    const apagarNota = notaId => {
        confirm({
            title: "Pretende apagar a nota?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/aproveitamento/apagar-nota",
                    params: {
                        notaId
                    }
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", "Nota apagada.");

                        const registo = avaliacoes.find(x => x.notaId === notaId);
                        const updatedRecord = { ...registo, nota: null };
                        const updatedAvaliacoes = avaliacoes.map(registro => {
                            if (registro.key === updatedRecord.key) {
                                return updatedRecord;
                            }
                            return registro;
                        });
                        setAvaliacoes(updatedAvaliacoes);
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível apagar a nota.");
                    });
            }
        });
    };

    const apagarObservacao = notaId => {
        confirm({
            title: `Pretende apagar ${entidadeId == 33 ? "o conteúdo avaliativo" : "a observação"}?`,
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/aproveitamento/apagar-observacoes",
                    params: {
                        notaId
                    }
                })
                    .then(response => {
                        openNotificationWithIcon(
                            "success",
                            "Sucesso",
                            `${entidadeId == 33 ? "Conteúdo avaliativo apagado" : "Observação apagada"}.`
                        );

                        const registo = avaliacoes.find(x => x.notaId === notaId);
                        const updatedRecord = { ...registo, observacoes: null };
                        const updatedAvaliacoes = avaliacoes.map(registro => {
                            if (registro.key === updatedRecord.key) {
                                return updatedRecord;
                            }
                            return registro;
                        });
                        setAvaliacoes(updatedAvaliacoes);
                    })
                    .catch(error => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            `Não foi possível apagar ${entidadeId == 33 ? "o conteúdo avaliativo" : "a observação"}.`
                        );
                    });
            }
        });
    };

    const apagarCampoNaoGuardado = (notaId, campo, title) => {
        confirm({
            title: [title],
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                const registo = avaliacoes.find(x => x.key === notaId);
                const updatedRecord = { ...registo, [campo]: null };
                const updatedAvaliacoes = avaliacoes.map(registro => {
                    if (registro.key === updatedRecord.key) {
                        return updatedRecord;
                    }
                    return registro;
                });

                setAvaliacoes(updatedAvaliacoes);
            }
        });
    };

    const trocarAluno = tipo => {
        carregouRef.current = false;

        const index = alunos.findIndex(x => x.code === match.params.code);
        let aluno = null;
        if (tipo === "ANTERIOR") aluno = alunos[index - 1];
        else aluno = alunos[index + 1];

        const { code, aluno: nome } = aluno;

        localStorage.setItem(code, nome);
        history.push(
            `/gerir-multisseriado/${match.params.turma
                .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                .toLowerCase()}/aproveitamento-conceitos-alunos/${code}`
        );
    };

    const trocarPeriodo = tipo => {
        carregouRef.current = false;

        const grupo = JSON.parse(localStorage.getItem("grupo"));
        const grupos = JSON.parse(localStorage.getItem("grupos"));
        const index = grupos.findIndex(g => g.id === grupo.id);

        let _grupo = null;
        if (tipo === "ANTERIOR") _grupo = grupos[index - 1];
        else _grupo = grupos[index + 1];

        localStorage.setItem("grupo", JSON.stringify(_grupo));

        let aluno = null;
        if (tipo === "ANTERIOR") aluno = alunos[alunos.length - 1];
        else aluno = alunos[0];

        const { code, aluno: nome } = aluno;

        localStorage.setItem(code, nome);
        history.push(
            `/gerir-detalhe-turma/${match.params.turma
                .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                .toLowerCase()}/aproveitamento-conceitos-alunos/${code}`
        );
    };

    const components = {
        body: {
            row: EditableFormRow,
            cell: EditableCell
        }
    };

    const guardarRascunhoPauta = async () => {
        const aulaId = localStorage.getItem("aula_diario");

        if (!aulaId) return;

        const lista = avaliacoes
            .filter(avaliacao => avaliacao.notaAlterada || avaliacao.observacaoAlterada)
            .map(avaliacao => {
                const obj = {
                    id: avaliacao.key
                };

                if (avaliacao.notaAlterada) obj.nota = avaliacao.nota;
                if (avaliacao.observacaoAlterada) obj.observacoes = avaliacao.observacoes;

                return obj;
            });

        let item = new FormData();
        item.append("code", match.params.code);
        item.append("pauta", JSON.stringify(lista));

        axios({
            method: "put",
            url: "/api/turma/guardar-pauta-conceitos-aluno-rascunho",
            data: item
        })
            .then(() => {
                context.atualizarState({
                    existeRascunhoGuardado: true
                });
            })
            .catch(() => {
                context.atualizarState({
                    existeRascunhoGuardado: false
                });
            });
    };

    const tentarGuardarRascunho = useCallback(() => {
        if (!alteradoPeloUserRef.current) return;
        guardarRascunhoPauta();
        alteradoPeloUserRef.current = false;
    }, [avaliacoes]);

    useEffect(() => {
        clearTimeout(autoSaveTimeoutRef.current);

        autoSaveTimeoutRef.current = setTimeout(() => {
            tentarGuardarRascunho();
        }, 500);

        return () => clearTimeout(autoSaveTimeoutRef.current);
    }, [avaliacoes]);

    useEffect(() => {
        listar();
        carregarRascunhoPauta();
        info();
        legendasConceitos();
        setGrupoInfo(JSON.parse(localStorage.getItem("grupo")));

        if (!alunos.length) setAlunos(JSON.parse(localStorage.getItem("alunos")));

        if (localStorage.getItem(match.params.code)) {
            setAluno(localStorage.getItem(match.params.code));
        }
    }, [location.pathname, context.acessos, match.params.code]);

    const exibirNotificacaoEReiniciarFlag = useCallback(() => {
        if (context.existeRascunhoGuardado) {
            openNotificationWithIcon("success", "Rascunho guardado", "Os dados foram salvos como rascunho.");

            context.atualizarState({
                existeRascunhoGuardado: false
            });
        }
    }, [context]);

    const editavel = acesso?.update;

    const isNivelEI = geralContext.nivelTurma?.trim().toLowerCase() === "educação infantil";

    const renderNota = (text, record) => (
        <span className="grupo-inserir-nota">
            {text ? (
                <span className={`tags-aproveitamento ${record.cor}`}>{text}</span>
            ) : (
                <span className={`campo-inserir-nota${!(record.permissao || record.permissaoAdm) ? " campo-inserir-nota-bloqueado" : ""}`}>
                    <strong></strong>
                </span>
            )}

            {acessoApagarRegistos && record.nota && editavel && (record.permissao || record.permissaoAdm) && (
                <Link
                    to="#"
                    className="botao-icon-inativar"
                    onClick={event => {
                        alteradoPeloUserRef.current = true;
                        event.stopPropagation();
                        if (!record.guardadaBD) {
                            apagarCampoNaoGuardado(record.key, "nota", "Pretende apagar a nota?");
                        } else {
                            apagarNota(record.notaId);
                        }
                    }}
                >
                    <Icon type="close" />
                </Link>
            )}
        </span>
    );

    const renderObservacoes = (text, record) => (
        <span className="grupo-inserir-nota">
            <span
                className={`campo-inserir-nota${!(record.permissao || record.permissaoAdm) ? " campo-inserir-nota-bloqueado" : ""}`}
                style={record.restauradoRascunhoObservacoes ? { backgroundColor: "#fffbe6" } : {}}
            >
                <strong>{text ? (text.length > 20 ? `${text.substring(0, 20)}...` : text) : ""}</strong>
            </span>
            {acessoApagarRegistos && record.observacoes && editavel && (record.permissao || record.permissaoAdm) && (
                <Link
                    to="#"
                    className="botao-icon-inativar"
                    onClick={event => {
                        alteradoPeloUserRef.current = true;
                        event.stopPropagation();
                        if (!record.guardadaBD) {
                            apagarCampoNaoGuardado(
                                record.key,
                                "observacoes",
                                `Pretende apagar ${entidadeId == 33 ? "o conteúdo avaliativo" : "a observação"}?`
                            );
                        } else {
                            apagarObservacao(record.notaId);
                        }
                    }}
                >
                    <Icon type="close" />
                </Link>
            )}
        </span>
    );

    let columns = [
        {
            title: "Pauta",
            dataIndex: "nome",
            render: (text, record) => text
        },
        {
            title: isNivelEI && entidadeId === "33" ? "Conceito" : "Nota",
            dataIndex: "nota",
            width: 150,
            editable: editavel,
            render: renderNota
        }
    ];

    if ((!isNivelEI && entidadeId === "33") || entidadeId !== "33")
        columns = [
            ...columns,
            {
                title: entidadeId == 33 ? "Conteúdo avaliativo" : "Observações",
                dataIndex: "observacoes",
                editable: editavel,
                render: renderObservacoes
            }
        ];

    columns = [
        ...columns,
        {
            title: "",
            dataIndex: "opcoes",
            width: 10
        }
    ];

    const columnsClick = columns.map(col => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: record => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave
            })
        };
    });

    const grupo = JSON.parse(localStorage.getItem("grupo"));
    const grupos = JSON.parse(localStorage.getItem("grupos"));
    const botaoPeriodoAnteriorVisivel = grupos.findIndex(g => g.id === grupo.id) > 0;
    const botaoPeriodoProximoVisivel = grupos.findIndex(g => g.id === grupo.id) < grupos.length - 1;

    const botaoAnteriorBloqueado = !(alunos.findIndex(x => x.code === match.params.code) > 0 || !alunos.length);
    const botaoProximoBloqueado = !(alunos.findIndex(x => x.code === match.params.code) < alunos.length - 1 || !alunos.length);

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <div className="container container-body">
            <div className="turma-resultados">
                <div className="controlos controlos-fundo" style={{ justifyContent: "flex-end" }}>
                    <div className="bloco-direita">
                        {!campoCalculado && acesso?.update && (
                            <Link
                                className={`botao-icon-print botao-maior ${
                                    estado === "PUBLICADO" || estado === "VALIDADO" ? "botao-disabled" : ""
                                }`}
                                disabled={estado === "VALIDADO"}
                                to="#"
                                title="Importar"
                                onClick={() => document.getElementById("upload-doc").click()}
                            >
                                <Icon type="upload" />
                            </Link>
                        )}
                        <Link className="botao-icon-download botao-maior" to="#" title="Exportar" onClick={exportarExcel}>
                            <Icon type="download" />
                        </Link>
                        <Link
                            to={`/gerir-multisseriado/${match.params.turma
                                .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                                .toLowerCase()}/aproveitamento-conceitos-lista-alunos`}
                            className="botao-secundario botao-secundario-redondo"
                            style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                            onClick={() => exibirNotificacaoEReiniciarFlag()}
                        >
                            <Icon type="arrow-left" />
                        </Link>
                    </div>
                </div>
                <div className="bloco">
                    <div className="info" style={{ display: "block" }}>
                        <div className="info-header-conceitos">
                            <div className="titulo-item">
                                <div style={{ fontSize: 16 }}>{grupoInfo.nome}</div>
                                {botaoPeriodoAnteriorVisivel && botaoAnteriorBloqueado && (
                                    <Link className="botao-icon-clip" to="#" title="Anterior" onClick={() => trocarPeriodo("ANTERIOR")}>
                                        <Icon type="left" />
                                    </Link>
                                )}
                                {botaoPeriodoProximoVisivel && botaoProximoBloqueado && (
                                    <Link className="botao-icon-clip" to="#" title="Proximo" onClick={() => trocarPeriodo("PROXIMO")}>
                                        <Icon type="right" />
                                    </Link>
                                )}
                            </div>
                            <div className="titulo-item">
                                <Link
                                    className={`botao-icon-clip ${botaoAnteriorBloqueado ? "botao-icon-clip-disable" : ""}`}
                                    disabled={botaoAnteriorBloqueado}
                                    to="#"
                                    title="Anterior"
                                    onClick={() => trocarAluno("ANTERIOR")}
                                >
                                    <Icon type="left" />
                                </Link>
                                <Link
                                    className={`botao-icon-clip ${botaoProximoBloqueado ? "botao-icon-clip-disable" : ""}`}
                                    disabled={botaoProximoBloqueado}
                                    to="#"
                                    title="Proximo"
                                    onClick={() => trocarAluno("PROXIMO")}
                                >
                                    <Icon type="right" />
                                </Link>
                                <div style={{ fontSize: 20 }}>{aluno}</div>
                            </div>
                            <p className="estado" dangerouslySetInnerHTML={{ __html: texto }}></p>
                        </div>
                    </div>
                    {entidadeId === "33" && (
                        <div style={{ marginBottom: 8 }}>
                            {legendas?.map(e => (
                                <div style={{ padding: 5 }}>
                                    <strong>{e.nome}. </strong>
                                    {e.legenda}
                                </div>
                            ))}
                        </div>
                    )}
                    <Table
                        id="cursos-disciplinas"
                        loading={{
                            spinning: loading,
                            indicator: (
                                <div className="loading-data-table">
                                    <div className="loading" />
                                </div>
                            )
                        }}
                        rowClassName={record => (record.permissao || record.permissaoAdm ? "editable-row" : "disable-row")}
                        components={components}
                        columns={columnsClick}
                        dataSource={avaliacoes}
                        pagination={false}
                        locale={{ emptyText: "Não existem dados!" }}
                    />
                    {avaliacoes.some(av => av.permissao || av.permissaoAdm) && (
                        <div className="bloco-controls">
                            <Link className="botao-principal" to="#" onClick={guardar}>
                                Salvar
                            </Link>
                        </div>
                    )}
                </div>
            </div>
            <ModalGerarDocumento
                visibleExportar={visibleExport}
                ficheiroExportar={exportFile}
                btnDescarregar={buttonDownload}
                onClose={() => setVisibleExport(false)}
            />
            <ModalLoading visible={visibleLoading} text={loadingText} />
            <DrawerLogs notaId={notaId} visible={visibleDrawerLogs} onClose={() => setVisibleDrawerLogs(false)} />
            <DrawerAlterarConceito
                notaId={notaId}
                visible={visibleDrawerAlterarNota}
                onClose={() => setVisibleDrawerAlterarNota(false)}
                atualizar={() => {
                    setVisibleDrawerAlterarNota(false);
                    listar();
                }}
            />
            <DrawerDataLimiteNota
                Id={notaId}
                utilizadorId={base64DecodeToLong(match.params.code)}
                avaliacaoId={avaliacaoId}
                visible={visibleDrawerAlterarDataNota}
                onClose={() => setVisibleDrawerAlterarDataNota(false)}
            />
            <input
                type="file"
                id="upload-doc"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={uploadFoto}
                style={{ display: "none" }}
            />
        </div>
    );
};

export default withRouter(Detalhe);
